import type { BrandKit } from "@redotech/redo-model/brand-kit";
import type { OrderLookupSettings } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as z from "zod/v4";

export const getTrackingPageForStorefront = {
  name: "getTrackingPageForStorefront" as const,
  input: z.object({}),
  output: z.object({
    orderLookupSettings: z.custom<OrderLookupSettings>().nullish(),
    brandKit: z.custom<BrandKit>().nullish(),
    widgetSlug: z.string().nullish(),
  }),
};
